// Generated by Melange

import * as Caml_js_exceptions from "melange.js/caml_js_exceptions.js";
import * as Caml_obj from "melange.js/caml_obj.js";
import * as Curry from "melange.js/curry.js";
import * as Mapre_web__Browser from "./browser.js";
import * as Mapre_web__Web_model from "./web_model.js";
import * as Mapre_web__Web_session_usage_model from "./web_session_usage_model.js";
import * as Mapre_wire__Json from "../../shared/wire/json.js";
import * as Stdlib__Option from "melange/option.js";

function cancel(t) {
  t.generation = t.generation + 1 | 0;
  Mapre_web__Browser.abort(t.controller);
  t.controller = new AbortController();
}

function current(t, workspace, session, generation) {
  const model = Curry._1(t.model, undefined);
  if (generation !== t.generation) {
    return false;
  }
  if (Mapre_web__Web_model.locked(model)) {
    return false;
  }
  if (!Caml_obj.caml_equal(model.session_panel, /* Usage_panel */ 3)) {
    return false;
  }
  const match = model.route;
  if (/* tag */ typeof match !== "object" && typeof match !== "function" || !(match.TAG === /* Session */ 3 && match._0 === workspace)) {
    return false;
  } else {
    return match._2 === session;
  }
}

function receive(t, session, selected, json) {
  if (json.TAG === /* Ok */ 0) {
    const json$1 = json._0;
    try {
      const action = selected !== undefined ? ({
          TAG: /* Detailed */ 3,
          _0: Mapre_web__Web_session_usage_model.decode_detail(session, selected, json$1)
        }) : ({
          TAG: /* Loaded */ 2,
          _0: Mapre_web__Web_session_usage_model.decode(session, json$1)
        });
      return Curry._1(t.emit, {
        TAG: /* Session_usage */ 39,
        _0: action
      });
    }
    catch (raw_exn){
      const exn = Caml_js_exceptions.internalToOCamlException(raw_exn);
      if (exn.MEL_EXN_ID === Mapre_wire__Json.Invalid) {
        return Curry._1(t.emit, {
          TAG: /* Session_usage */ 39,
          _0: {
            TAG: /* Failed */ 4,
            _0: "Invalid session usage response."
          }
        });
      }
      throw exn;
    }
  } else {
    const code = json._0;
    if (/* tag */ typeof code !== "object" && typeof code !== "function") {
      if (code === /* Invalid_response */ 2) {
        return Curry._1(t.emit, {
          TAG: /* Session_usage */ 39,
          _0: {
            TAG: /* Failed */ 4,
            _0: "Invalid session usage response."
          }
        });
      }
      Curry._1(t.emit, {
        TAG: /* Session_usage */ 39,
        _0: {
          TAG: /* Failed */ 4,
          _0: "Unable to read session usage."
        }
      });
      return Curry._1(t.failure, code);
    } else {
      if (code.TAG === /* Failed */ 1) {
        return Curry._1(t.emit, {
          TAG: /* Session_usage */ 39,
          _0: {
            TAG: /* Failed */ 4,
            _0: code._0
          }
        });
      }
      Curry._1(t.emit, {
        TAG: /* Session_usage */ 39,
        _0: {
          TAG: /* Failed */ 4,
          _0: "Unable to read session usage."
        }
      });
      return Curry._1(t.failure, code);
    }
  }
}

function load(t, workspace, session, selected) {
  cancel(t);
  Curry._1(t.emit, {
    TAG: /* Session_usage */ 39,
    _0: {
      TAG: /* Loading */ 1,
      _0: selected
    }
  });
  const generation = t.generation;
  const path = "/api/workspaces/" + (workspace + ("/sessions/" + (session + ("/usage" + Stdlib__Option.fold("", (function (run) {
    return "?run_id=" + run;
  }), selected)))));
  Mapre_web__Browser.request(t.controller, undefined, undefined, path).then(function (result) {
    if (current(t, workspace, session, generation)) {
      receive(t, session, selected, result);
    }
    return Promise.resolve();
  });
}

function dispatch(t, action) {
  const match = Curry._1(t.model, undefined).route;
  if (/* tag */ typeof match !== "object" && typeof match !== "function") {
    return;
  }
  if (match.TAG !== /* Session */ 3) {
    return;
  }
  const session = match._2;
  const workspace = match._0;
  if (Mapre_web__Web_model.locked(Curry._1(t.model, undefined))) {
    return;
  }
  if (!/* tag */ (typeof action !== "object" && typeof action !== "function")) {
    if (action.TAG === /* Select */ 0 && Caml_obj.caml_equal(Curry._1(t.model, undefined).session_panel, /* Usage_panel */ 3)) {
      return load(t, workspace, session, action._0);
    } else {
      return;
    }
  }
  if (action !== /* Open */ 0) {
    if (Caml_obj.caml_equal(Curry._1(t.model, undefined).session_panel, /* Usage_panel */ 3)) {
      return load(t, workspace, session, Curry._1(t.model, undefined).session_usage.selected);
    } else {
      return;
    }
  }
  Curry._1(t.emit, {
    TAG: /* Open_session_panel */ 51,
    _0: /* Usage_panel */ 3
  });
  load(t, workspace, session, undefined);
}

function create(emit, model, failure) {
  return {
    emit,
    model,
    failure,
    generation: 0,
    controller: new AbortController()
  };
}

export {
  create,
  cancel,
  dispatch,
}
/* Mapre_web__Browser Not a pure module */
